import { Location } from 'react-router-dom';

import { getCurrentCountry } from '@front/common/src/utils/country';
import {
  CUSTOMER_AREA_ORDER_PATH_BY_COUNTRY,
  CUSTOMER_AREA_POTENTIAL_PATH_BY_COUNTRY,
} from '@front/common/src/constants/country';

import {
  getInstantTaxCreditFunnelUrl,
  getRecurringChildcareCalendlyUrl,
  GetRecurringChildcareCalendlyUrlFunc,
} from '@front/customer/src/utils/navigation';

import { route } from '../steps/steps';
import { LocationState } from '../types';

export const getPreviousPath = (location?: Location<LocationState>) =>
  location && location.state && location.state.from ? location.state.from : route('root');

export const getNextPath = (location?: Location<LocationState>) =>
  (location && location.state && location.state.to) || undefined;

export const goToInstantTaxCreditFunnel = (potentialPublicId: string) => {
  window.location.replace(
    getInstantTaxCreditFunnelUrl({
      siteUrl: window.wecasa.siteUrl,
      searchParams: { potential_public_id: potentialPublicId },
    }),
  );
};

export const goToPotentialInfoAfterModification = (potentialPublicId: string) => {
  const { siteUrl, locale } = window.wecasa;

  window.location.replace(
    `${siteUrl}${locale}/${CUSTOMER_AREA_POTENTIAL_PATH_BY_COUNTRY[getCurrentCountry()]}${potentialPublicId}?track_booking_updated=true`,
  );
};

export const goToOrderInfoAfterModification = (orderPublicId: string) => {
  const { siteUrl, locale } = window.wecasa;

  window.location.replace(
    `${siteUrl}${locale}/${CUSTOMER_AREA_ORDER_PATH_BY_COUNTRY[getCurrentCountry()]}${orderPublicId}?track_booking_updated=true`,
  );
};

export const goToRecurringChildcareCalendly = (...args: Parameters<GetRecurringChildcareCalendlyUrlFunc>) =>
  window.open(getRecurringChildcareCalendlyUrl(...args), '_blank');

export const goToWecasaHomePage = () => window.location.replace(window.wecasa.siteUrl || '');
